"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoholeLake = void 0;
const Tags_1 = require("./../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("./../CardType");
const CardName_1 = require("../../CardName");
const ResourceType_1 = require("../../ResourceType");
const SelectCard_1 = require("../../inputs/SelectCard");
const PlaceOceanTile_1 = require("../../deferredActions/PlaceOceanTile");
const CardRenderer_1 = require("../render/CardRenderer");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Units_1 = require("../../Units");
class MoholeLake extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.MOHOLE_LAKE,
            tags: [Tags_1.Tags.BUILDING],
            cost: 31,
            tr: { temperature: 1, oceans: 1 },
            metadata: {
                cardNumber: 'X27',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Add a microbe or animal to ANOTHER card.', (eb) => {
                        eb.empty().startAction.microbes(1).asterix();
                        eb.nbsp().or().nbsp().animals(1).asterix();
                    }).br;
                    b.plants(3).temperature(1).oceans(1);
                }),
                description: 'Gain 3 plants. Raise temperature 1 step, and place 1 ocean tile.',
            },
        });
    }
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        player.game.increaseTemperature(player, 1);
        player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player));
        player.plants += 3;
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        const availableCards = player.getResourceCards(ResourceType_1.ResourceType.MICROBE).concat(player.getResourceCards(ResourceType_1.ResourceType.ANIMAL));
        if (availableCards.length === 0) {
            return undefined;
        }
        if (availableCards.length === 1) {
            player.addResourceTo(availableCards[0], { log: true });
            return undefined;
        }
        return new SelectCard_1.SelectCard('Select card to add microbe or animal', 'Add resource', availableCards, (foundCards) => {
            player.addResourceTo(foundCards[0], { log: true });
            return undefined;
        });
    }
    getActionDetails(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainHeatProductionFromTemperatureIncrease(1) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({ card: card, temperatureIncrease: 1, oceansToPlace: 1, bonusMegaCredits: bonusMegaCredits });
    }
}
exports.MoholeLake = MoholeLake;
//# sourceMappingURL=MoholeLake.js.map